import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'ups-avatar',
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-block flex-shrink-0' 
  },
  imports: [
    CommonModule
  ]
})
export class AvatarComponent implements OnChanges {

  @Input() public src!: string;
  @Input() public size: string = '44px';

  constructor(
    protected readonly chRef: ChangeDetectorRef
  ) { }

  public ngOnChanges({ src }: SimpleChanges): void{
    if (src) this.chRef.markForCheck();
  }

  public setDefault({ target }: any): void{ target.src = '/assets/images/avatar.webp'; }
}
